module.exports = __webpack_public_path__ + "static/WEDDING E&M-531-8dbb0848935340dfce5ff7471a0a26b1.jpg";